
import { timer as observableTimer, fromEvent as observableFromEvent, Observable, Subscription } from 'rxjs';

import { debounceTime } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { Authentication } from '@platform-idm/sdk-javascript';
import { PlatformIdmService } from '@platform-idm/sdk-angular';

declare var McLogout: any;
declare var OktaEvents: any;

@Injectable()
export class ActivityService { 
  static readonly lastActivityCookieName = 'lastActivity';

  public sessionClosed = new EventEmitter();
  public timeoutWarning = new EventEmitter();
  sessionTimeoutTimer: Subscription;
  sessionWarningTimeoutTimer: Subscription;
  mouseMoveTimer: Subscription;
  keyPressTimer: Subscription;
  logoutTimer: Subscription;
  crossDomainCookieURL: string;

  public warningBeforeTimeoutInSeconds = 60;
  private logoutCheckIntervalInSeconds = 5;
  private initialDelay = 5;
  private idmAudh: Authentication;

  constructor(private router: Router, idmAuthService: PlatformIdmService) {
    this.idmAudh = idmAuthService.authentication;

    this.crossDomainCookieURL = environment.crossDomainCookieURL;
  }

 

  
}
